import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import { AnyAction, bindActionCreators, Dispatch } from 'redux'
import Winners, { ISkin } from '../../views/winners/Winners'
import viewSelector from '../../redux/selectors/winners/viewSelector'

import withTransition from '../../hoc/Transition'
import withResizer from '../../hoc/Resizer'
import { IWinnerPlayerData } from '../../helpers/data/winnerPlayer'
import { IStore } from '../../redux/reducers/index'
import appActions from '../../redux/actions/appActions'

interface IWinnersProps {
	players: IWinnerPlayerData[]
	skin: ISkin,
	isTimerDisabled: number
	gameEnd: () => void
}

class WinnersConnector extends PureComponent<IWinnersProps> {
	render() {
		return <Winners players={this.props.players} skin={this.props.skin} isTimerDisabled={this.props.isTimerDisabled} onGameEnd={this.props.gameEnd} />
	}
}

const mapStateToProps = (state: IStore) => {
	return viewSelector(state)
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
	return bindActionCreators(
		{
			gameEnd: appActions.gameEnd,
		},
		dispatch
	)
}

export default withTransition(withResizer(connect(mapStateToProps, mapDispatchToProps)(WinnersConnector), 1024, 768))
